import * as React from "react";
import "../../style/fonts.css";
import "./cookieConsent.css";
import CookieConsent from "react-cookie-consent";
import translate from "../../translations/i18n";
import {
  cookiesAccept,
  cookiesDeclined
} from "../../store/actions/cookieActions";
import { compose } from "redux";
import { connect } from "react-redux";

export interface Props {
  cookiesAccept(): void;
  cookiesDeclined(): void;
}

class CookieConsentBan extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.cookieAccept = this.cookieAccept.bind(this);
    this.cookieDecline = this.cookieDecline.bind(this);
  }

  cookieAccept() {
    this.props.cookiesAccept();
  }

  cookieDecline() {
    this.props.cookiesDeclined();
  }

  render() {
    if (window.location.href.includes("inApp")) {
      return <div></div>;
    }

    return (
      <CookieConsent
        disableStyles={true}
        buttonClasses="CTA_COOKIE"
        buttonText={translate("COOKIE_WEBAPP_CTA")}
        containerClasses="COOKIE_CONSENT_CONT"
        onAccept={this.cookieAccept}
        onDecline={this.cookieDecline}
        // acceptOnScroll={true}
        // acceptOnScrollPercentage={100}
      >
        <div className="COOKIE_TEXT">{translate("COOKIE_WEBAPP_TEXT")}</div>
      </CookieConsent>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    cookiesAccept: () => dispatch(cookiesAccept()),
    cookiesDeclined: () => dispatch(cookiesDeclined())
  };
};

export default compose<any>(connect(null, mapDispatchToProps))(
  CookieConsentBan
);



// WEBPACK FOOTER //
// ./src/components/cookieConsent/cookieConsent.tsx